import React, { Component } from 'react';
import axios from 'axios'
import qs from 'qs'
import Alert from 'react-s-alert'
import queryString from 'query-string'
import { updateStatusLogin } from '../../../actions/authAction'
import { updateDomain } from "../../../actions/domainAction"
import { sekolahApiVersion } from "../../../constants/general"
import { SERVER_API, SERVER_API_SISMART } from '../../../constants/siteConfig'
import logo from '../../../images/logo_sismart.png'
import bismart from '../../../images/bismart.png'
import sdipbs from '../../../images/sdipbs.png'
import instagram from '../../../images/instagram.png'
import facebook from '../../../images/facebook.png'
import twitter from '../../../images/twitter.png'
import {NavLink} from "react-router-dom";
import md5 from "md5";

var backgroundcolor = '#a32a86c7';
class Login extends Component {
    constructor() {
        super()

        this.state = {
            user_username: "",
            user_password: "",
            nmsekolah:"",
            sekolah_kode:"",
            logo_user_kodesekolah: "",
            user_kodesekolah: "",
            idsekolah: "",
            buttonIsLoading: false
        }

        this.handleLogin  = this.handleLogin.bind(this)
        this.handlefb  = this.handlefb.bind(this)
        this.handletwtr  = this.handletwtr.bind(this)
        this.handleig  = this.handleig.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.getkodesekolah = this.getkodesekolah.bind(this)
    }
    async handleLogin() {
        this.setState({ buttonIsLoading: true })

        const apiSismart = await this.fireApiSismart()

        if (apiSismart.status) {

            const domain = apiSismart.data.sekolah_server_domain + sekolahApiVersion;

            this.props.dispatch(updateDomain(domain));

            this.fireApiLogin();

        } else {
            this.setState({ buttonIsLoading: false });
            Alert.error(apiSismart.text)
        }
    }
    _handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.handleLogin();
        }
    }

    async getkodesekolah() {

        let params = queryString.parse(this.props.location.search)
        this.setState({
            logo_user_kodesekolah: params.kode,
            idsekolah:params.id,
        })
    }

    async handlefb(){
        window.open( "https://www.facebook.com/Sismart/")
    }

    async handletwtr(){
        window.open( "https://twitter.com/SISMARTOFFICIA1")
    }

    async handleig(){
        window.open( "https://www.instagram.com/officialsismart/")
    }

    fireApiSismart() {
        const user_codesekolah = this.state.idsekolah === "sekolah" ? this.state.logo_user_kodesekolah : this.state.user_kodesekolah;
        return axios({
            method: "post",
            data: qs.stringify({ code: user_codesekolah }),
            baseURL: SERVER_API_SISMART,
            url: "/sekolah"
        })
            .then(response => response.data)
            .then(data => {
                if (data.status) {

                    this.setState(
                        {nmsekolah:data.data.sekolahs[0].sekolah_nama, sekolah_kode: data.data.sekolahs[0].sekolah_kode}
                    )
                    return { status: true, text: "", data: data.data.sekolahs[0] };
                } else {
                    throw new Error();
                }
            })
            .catch(err => {
                return { status: false, text: "School Code isn't valid. Please try again..", data: null };
            });
    }

    fireApiLogin() {

        this.setState({buttonIsLoading: true})
        const user_codesekolah = this.state.idsekolah === "sekolah" ? this.state.logo_user_kodesekolah : this.state.user_kodesekolah;
        const params = {
            user_username : this.state.user_username, 
            // user_password : this.state.user_password,
            user_password : md5(md5(this.state.user_password)),
        }

        axios({
            method: 'post',
            data: qs.stringify(params),
            baseURL: SERVER_API+ user_codesekolah +"/apischool",
            url: '/login'
        })
            .then(response => {

                const result = response.data;
                if ( ! result.success) {

                    Alert.error(result.message)
                }
                else {
                    if (result.data.user_status === "1") {
                        localStorage.SISMART_IS_LOGIN = true;
                        localStorage.NMSEKOLAH = this.state.nmsekolah;
                        localStorage.SISMART_USER_ID = result.data.user_id;
                        localStorage.SISMART_USER_LEVEL = result.data.user_level;
                        localStorage.SISMART_USER_NAMA = result.data.user_nama;
                        localStorage.SISMART_USER_FOTO = result.data.user_foto;
                        localStorage.SISMART_USER_USERNAME = result.data.user_username;
                        localStorage.SISMART_USER_STATUS = result.data.user_status;
                        localStorage.SECOLAH_CODE = this.state.sekolah_kode;
                        localStorage.IDBISMART = this.state.idsekolah;
                        localStorage.TOKEN = result.token;

                        this.props.dispatch(updateStatusLogin(true, result.data.user_id, result.data.user_level, result.data.user_nama, result.data.user_foto, result.data.user_username, result.data.user_status))
                        window.location.reload();
                        Alert.success("Selamat datang kembali..")
                    }
                    else {

                        Alert.error("Akun anda tidak aktif")
                    }
                }

                this.setState({buttonIsLoading: false})
            })
            .catch(error => {
                console.log(error)
                this.setState({buttonIsLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;
        this.setState({
            [name]: value
        })
    }



    render() {

        return (


            <div onLoad={this.getkodesekolah}   className="app-2 flex-row align-items-center">

                <div className="container">

                    <div className="row justify-content-center">
                        <div   className="col-md-5" >
                            <div className="card-group-2 mb-0">
                                <div className="card p-3">
                                    <div  className="card-block-2">
                                        {this.state.logo_user_kodesekolah === "sdipbs"  ? (
                                        <img src={sdipbs} style={{width: "50%" }} className="center"  alt=""  />
                                        ) : this.state.logo_user_kodesekolah === "smkbnif"  ? (
                                            <img src={bismart} style={{width: "50%" }} className="center"  alt=""  />
                                        ):( <img src={logo} style={{width: "70%" }} className="center"  alt=""  />
                                            )}
                                        <br/>
                                        {/*{  user_kodesekolah === "" }(*/}
                                        <div className="input-group mb-3">
                                            <span className="input-group-addon"><i className="icon-key"></i></span>
                                            <input
                                                type="text"
                                                name="user_kodesekolah"
                                                value={this.state.idsekolah === "sekolah" ? this.state.logo_user_kodesekolah : this.state.user_kodesekolah}
                                                onChange={this.handleChange}
                                                disabled = {this.state.idsekolah === "sekolah" ? true : false}
                                                className="form-control"
                                                placeholder="Kode Sekolah"/>
                                        </div>
                                        {/*// ) : (*/}
                                        {/*<div className="input-group mb-3">*/}
                                        {/*    <span className="input-group-addon"><i className="icon-key"></i></span>*/}
                                        {/*    <input*/}
                                        {/*        type="text"*/}
                                        {/*        name="user_kodesekolah"*/}
                                        {/*        disabled="disabled"*/}
                                        {/*        value={this.state.user_kodesekolah}*/}
                                        {/*        onChange={this.handleChange}*/}
                                        {/*        className="form-control"*/}
                                        {/*        placeholder="Kode Sekolah"/>*/}
                                        {/*</div>*/}
                                        {/*); }*/}
                                        <div className="input-group mb-3">
                                            <span className="input-group-addon"><i className="icon-user"></i></span>
                                            <input
                                                type="text"
                                                name="user_username"
                                                value={this.state.user_username}
                                                onChange={this.handleChange}
                                                className="form-control"
                                                placeholder="Username Anda"/>
                                        </div>


                                        <div className="input-group mb-4">
                                            <span className="input-group-addon"><i className="icon-lock"></i></span>
                                            <input
                                                type="password"
                                                name="user_password"
                                                value={this.state.user_password}
                                                onChange={this.handleChange}
                                                className="form-control"
                                                onKeyDown={this._handleKeyDown}
                                                placeholder="Password Anda"/>
                                        </div>


                                        <div className="center">
                                            <div  className="row">
                                                <button
                                                    type="button"

                                                    className="btn btn-primary-2 px-xl-5"
                                                    onClick={this.handleLogin}
                                                >
                                                    {this.state.buttonIsLoading ? 'Loading...' : 'Login'}
                                                </button>



                                            </div>

                                            <br/><br/>
                                        </div>

                                        <p className="center">
                                            <button onClick={this.handlefb} className="btn btn-brand btn-facebook" type="button" style={{margin:"4px"}} >
                                                <i className="fa fa-facebook"></i></button>
                                            <button onClick={this.handletwtr} className="btn btn-brand btn-twitter" type="button" style={{margin:"4px"}} >
                                                <i className="fa fa-twitter"></i></button>
                                            <button onClick={this.handleig} className="btn btn-brand btn-instagram" type="button" style={{margin:"4px"}}>
                                                <i className="fa fa-instagram"></i></button>
                                        </p>
                                        <br/>

                                        <footer>
                                            <div className="center" >
                                                <strong>&copy;2017-2019</strong>
                                                <NavLink to="/">{" "}
                                                    <strong>CMS-SISMART</strong>
                                                </NavLink>{" "}
                                                <span>
                                                <strong>Version</strong> {" "} 2.4.0</span>
                                            </div>
                                        </footer>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js